export function esEstrellasCalificacionValidas(n) {
  const x = Number(n);
  return Number.isInteger(x) && x >= 1 && x <= 5;
}
